<template>
  <div>
    <v-card color="Neutral" flat class="image-viewer-card overflow-y-auto">
      <v-card-text v-if="file_count > 1">
        <v-carousel
          :cycle="cycle"
          show-arrows-on-hover
          hide-delimiter-background
          color="error"
          interval="10000"
          reverse-transition="fade-transition"
          transition="fade-transition"
          eager
        >
          <v-carousel-item v-for="(file, index) in imagesList" :key="index">
            <v-card class="mx-auto" elevation="5" max-width="70%">
              <v-img
                contain
                :src="file"
                :aspect-ratio="16 / 9"
                :class="{ 'v-image--auto': widget.is_image_auto_fit == '1' }"
              >
              </v-img>
            </v-card>
          </v-carousel-item>
        </v-carousel>
      </v-card-text>
      <v-card-text v-else>
        <v-card class="mx-auto" elevation="5" max-width="70%">
          <v-img
            v-for="(file, index) in imagesList"
            :key="index"
            contain
            :src="file"
            :aspect-ratio="16 / 9"
            :class="{ 'v-image--auto': widget.is_image_auto_fit == '1' }"
          >
          </v-img>
        </v-card>
      </v-card-text>
    </v-card>
  </div>
</template>
<style scoped>
::v-deep .v-image {
  z-index: 0;
  height: 100% !important;
}

::v-deep .v-image--auto .v-image__image--contain {
  background-size: auto !important;
}
::v-deep .v-carousel {
  overflow: hidden;
  position: relative;
  width: 100%;
  height: 100% !important;
  min-height: 500px !important;
}
</style>

<script>
import widgetService from "../../api/widgetService";
export default {
  name: "ImageSliderWidget",
  props: ["widget", "cycle"],
  data() {
    return {
      parentHeight: 0,
      imgList: [],
    };
  },
  computed: {
    fileList() {
      const tenant = sessionStorage.getItem("tenantId");
      const files = [];
      for (const file of this.widget.files) {
        const path = `${process.env.VUE_APP_CONFIG_SERVICE}widgets/${this.widget.id}&${file.fileId}?tenant=${tenant}`;
        files.push(path);
      }
      return files;
    },

    file_count() {
      return this.widget.files.length;
    },
    imagesList() {
      return this.imgList;
    },
  },
  async mounted() {
    await this.getWidgetFile();
    setTimeout(() => {
      const childCard = document.getElementsByClassName('image-viewer-card');
      if(childCard.length > 0) {
        for(let i = 0; i < childCard.length; i++) {
          this.parentHeight = childCard[i].parentElement.parentElement.parentElement.offsetHeight;
          if(childCard[i].parentElement.parentElement.children[0].childElementCount) {
            const height = childCard[i].parentElement.parentElement.children[0].offsetHeight;
            childCard[i].style.height = `${this.parentHeight - height}px`;
          }
        }
      }
    },500)
  },
  methods: {
    async getWidgetFile() {
      try {
        const tenant = sessionStorage.getItem("tenantId");
        let imgListItems = [];
        for (const file of this.widget.files) {
          const res = await widgetService.getWidgetFile(
            this.widget.id,
            file.fileId,
            tenant
          );
          imgListItems.push(window.URL.createObjectURL(res));
        }
        this.imgList = imgListItems;
      } catch (err) {
        console.log(`Received response: ${err}`);
        this.loading = false;
        //this.$emit("alert", "Something Went Wrong, Please Try Again", 'error');
      }
      // const res = await this.downloadDocumentAPI(item.documentId);
    },
  },
};
</script>
